<template>
  <div class="zbjl-box">
  	<div class="zbjl-box-container">
  		<div class="zbjl-mask-model-rect-user">
  			<div class="zbjl-mask-model-rect-user-left">
  				<img class="zbjl-mask-model-rect-user-left-img" :src="data.headPortrait" alt="" />
  				<div class="zbjl-mask-model-rect-user-content">
  					<span class="zbjl-mask-model-rect-user-content-span">{{data.nickName}}</span>
  					<span class="zbjl-mask-model-rect-user-content-span1">ID：{{data.recodeCode}}</span>
  				</div>
  			</div>
  			<img class="zbjl-mask-model-rect-user-img" src="../../assets/image/tanchuang_x_b@2x.png" alt="关闭" @click="handleCloseZbjl" />
  		</div>
  		<div class="zbjl-mask-model-rect-list" ref="listContainer" @scroll="handleScroll">
  			<div class="zbjl-mask-model-rect-list-title">{{$t('all.zhibojilu')}}</div>
  			<zbjlItem v-for="(item,index) in list" :key="index" :data="item"/>
  			<kong v-if="isKong"/>
  		</div>
  	</div>
  </div>
</template>

<script>
import { getChatRoomDetails,getChatRoomUserDetails,getUserLiveRecordList } from "@/api/zhibo";
import kong from "../kong/kong.vue";
import zbjlItem from "../zbjlItem/zbjlItem.vue";
export default {
  components: {
    kong,
	zbjlItem
  },
  data() {
    return {
	  data:'',
	  queryParams: {
	    page: 1,
	    size: 10,
		viewUserId:'',
		liveId:this.$route.query.liveId,
	  },
	  form:{
		liveId:this.$route.query.liveId,
		toUserId:''
	  },
	  list: [],
	  isKong:false,
	  hasMore: true,
	  // 1. 新增一个加载状态锁，防止重复请求
	  isLoading: false,
    };
  },
  mounted() {
	//直播间详情
	this.getChatRoomDetails()
  },
  methods: {
	async getChatRoomDetails(){
		const res = await getChatRoomDetails({liveId:this.$route.query.liveId})
		this.queryParams.viewUserId = res.data.chatRoomDetails.hostUserInfo.userId
		this.form.toUserId = res.data.chatRoomDetails.hostUserInfo.userId
		this.getChatRoomUserDetails()
		this.getUserLiveRecordList()
	},
	//直播间用户详情
	async getChatRoomUserDetails(){
		const res = await getChatRoomUserDetails(this.form)
		this.data = res.data
	},
	// 获取直播记录列表
	async getUserLiveRecordList() {
	  // 2. 如果正在加载或没有更多数据，则直接返回
	  if (this.isLoading || !this.hasMore) {
	    return;
	  }
	
	  try {
	    // 3. 发起请求前，将加载状态设为 true
	    this.isLoading = true;
	
	    const response = await getUserLiveRecordList(this.queryParams);
	    const newList = response.rows || [];
	
	    if (this.queryParams.page === 1) {
	      this.list = newList;
	    } else {
	      this.list = [...this.list, ...newList];
	    }
	
	    const totalPages = Math.ceil((response.total || 0) / this.queryParams.size);
	    this.hasMore = this.queryParams.page < totalPages;
	    if(response.total > 0){
			this.isKong = false
		}else{
			this.isKong = true
		}
	  } catch (error) {
	    console.error("获取直播记录列表失败:", error);
	  } finally {
	    // 4. 请求结束（无论成功或失败），将加载状态恢复为 false
	    this.isLoading = false;
	  }
	},
	
	// 滚动事件处理函数
	handleScroll() {
	  // 同样增加 isLoading 判断，防止在请求期间触发
	  if (this.isLoading || !this.hasMore) {
	    return;
	  }
	
	  const container = this.$refs.listContainer;
	  // 判断滚动条是否到达底部（或接近底部）
	  const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 10;
	
	  if (isAtBottom) {
	    console.log("滚动到底部，准备加载第", this.queryParams.page + 1, "页");
	    this.queryParams.page++;
	    this.getUserLiveRecordList();
	  }
	},
	//关闭直播记录
	handleCloseZbjl(){
		this.$emit('close_zbjl')
	}
	
  }
};
</script>
<style scoped lang="scss">
	@import "./zhibojilu.css";
</style>


// WEBPACK FOOTER //
// zhibojilu.vue?158eefb0